import classnames from 'classnames';
import React from 'react';

import Button from 'dpl/common/design_system/Button';

interface SimilarBreedsSectionFooterProps {
  onViewAllClick: () => void;
  className?: string | null;
}

/**
 * "View all" footer for the similar breeds carousel.
 *
 * A button rather than a link: the destination is an overlay on this same page,
 * opened through a hash param.
 */
export default function SimilarBreedsSectionFooter({
  onViewAllClick,
  className = null
}: SimilarBreedsSectionFooterProps) {
  return (
    <div
      className={classnames(
        'SimilarBreedsSectionFooter flex items-center gap-16',
        className
      )}
    >
      <Button
        className="nowrap font-16"
        data-test-id="similar_breeds_view_all_button"
        onClick={onViewAllClick}
        size="small"
        variant="primary"
      >
        View all
      </Button>
    </div>
  );
}
